module.exports = __webpack_public_path__ + "img/li.2c6c4297.jpg";